import axios from 'axios';

const getList = params => axios.get('/modos-pagamentos', {
  params,
});

export default {
  getList,
};
